type BasicInfoProps = {
  address: string
  state: string
  phone: string
}

const BasicInfo = ({ address, state, phone }: BasicInfoProps) => {
  const rows = [address, state, phone]

  return rows.map((row, i) => (
    <p key={String(i)} className="typography-body-l">
      {row}
    </p>
  ))
}

export default BasicInfo
